export default "__VITE_ASSET__CHdy4xgi__"